import axiosClient from "../../../../axiosClient"

const service = async (payload) => {
    const result = await axiosClient.post("/update-icover-credentials", payload)
    return result.data
}

export default service
